module.exports = __webpack_public_path__ + "img/eplogo-vertical-grid.092f7d2c.svg";